import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import Image from '@/components/Image';
import { ConvergingCardRowsCardDto } from '@/components/service-pages/ConvergingCardRows/types';
import { Typography } from '@/components/shared/Typography';
import css from './style.module.scss';
interface Props {
  data: ConvergingCardRowsCardDto;
}
const Card: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.image) {
    t1 = data.image ? <Image className={css.icon} width={78} height={78} src={data.image.url} alt="" /> : null;
    $[0] = data.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.title) {
    t2 = <Typography uppercase={true} variant="h6" tag="h3" className={css.title}>{data.title}</Typography>;
    $[2] = data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.text) {
    t3 = <Typography variant="body-m" tag="p" className={css.text}>{data.text}</Typography>;
    $[4] = data.text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={css.card}>{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default Card;